/**
 * Entry point for the ranks logic bundle
 * Combines all modules and exposes them to the global window object
 */

import * as core from "./core.js";
import * as dom from "./dom.js";
import * as render from "./render.js";

// Combine and expose to window for compatibility
const RanksLogic = {
  ...core,
  ...render,
  ...dom,
};

if (typeof window !== "undefined") {
  window.RanksLogic = RanksLogic;

  // Auto-initialize when DOM is ready
  document.addEventListener("DOMContentLoaded", () => {
    if (typeof dom.init === "function") {
      dom.init();
    }
  });
}

export default RanksLogic;
